
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 03/06/2025
 * @update 03/06/2025
 * @file src/components/W17/INVHotModal
 */

import {
    Button,
    ButtonIcon,
    Col,
    Image, Modal, ModalBody,
    ModalHeader,
    Row,
    Typography
} from 'diginet-core-ui/components';
import Icons from "diginet-core-ui/icons";
import React, { forwardRef, memo, useEffect, useMemo, useRef, useState } from 'react';
import Config from "../../config";
import FileViewer from "../common/fileviewer/fileviewer";
import { Loading } from "../common/loading/loading";

const listFilesType = ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'pdf', 'csv', 'doc', 'docx', 'xls', 'xlsx', 'mp4'];

const INVHotModal = memo(forwardRef((props, _) => {
    const { open, handleOpen, dataInfo } = props;
    const [formLoading, setFormLoading] = useState(false);
    const [showFileViewer, setShowFileViewer] = useState(false);
    const [readMore, setReadMore] = useState(false);
    const [dataMaster, setDataMaster] = useState({
        UnitID: '',
        DesINV: '',
        ImageINV: '',
        InventoryName: '',
        SpecificationsINV: '',
    });

    const dataFileView = useRef({});

    const { DiscountData = [], UnitID = '', ImageINV = '', InventoryName = '', SpecificationsINV = '', DesINV = '' } = dataMaster || {};

    useEffect(() => {
        loadForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadForm = () => {
        const { InventoryID = '' } = dataInfo || {};
        const params = {
            DataTypeID: 'LoadDetailINV',
            StrSearch: '',
            EmployeeID: '',
            QuotationID: '',
            InventoryID
        };
        setFormLoading(true);
        props.W17F0091Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
            } else if (data) {
                const dataObj = data?.[0] || {};
                if (Object.hasOwn(dataObj, 'DiscountData') && !Config.isEmpty(dataObj?.DiscountData)) {
                    let DiscountDataCustom = [];
                    for (let i = 0; i < dataObj.DiscountData.length; i++) {
                        const { DiscountFile } = dataObj.DiscountData[i] || {};
                        DiscountDataCustom.push({ ...dataObj.DiscountData[i], fileType: listFilesType.find(name => DiscountFile.search(name) > -1) })
                    }
                    dataObj.DiscountData = DiscountDataCustom;
                }
                setDataMaster(dataObj);
            }
        });
    };

    const handleViewFile = () => {
        setShowFileViewer(true);
    };

    const renderAttachment = useMemo(() => {
        if (Config.isEmpty(DiscountData)) return '';
        return DiscountData.map(item => {
            const { DiscountName = '', DiscountFile = '', fileType = '' } = item;
            const { color, name } = Config.getFileInfo(fileType);
            return <div className={'display_row align-center'}><div className={'display_row align-center pointer mgv2x'} onClick={() => {
                dataFileView.current = { fileName: DiscountName, filePath: DiscountFile, fileType };
                return handleViewFile();
            }}><Icons className={'mgh2x'} color={color} name={name} width={20} height={20} /><Typography>{DiscountName}</Typography></div>
                <ButtonIcon height={36} width={36} className={'mgh2x'} circular name={'Download'} viewType={'text'} onClick={() => {
                    const el = document.getElementById("linkDownload");
                    if (el) {
                        el.href = DiscountFile;
                        el.download = DiscountName;
                        el.click();
                    }
                }} />
            </div>
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DiscountData]);

    // Modal Order 
    return (
        <Modal open={open} size={'md'} onClose={() => handleOpen(false)}>
            <ModalHeader title={Config.lang('Chi_tiet_san_pham')} />
            <ModalBody>
                {showFileViewer && !Config.isEmpty(dataFileView.current) &&
                    <Modal open={showFileViewer} size={'lg'} onClose={() => setShowFileViewer(false)}>
                        <ModalHeader title={dataFileView.current?.fileName} />
                        <ModalBody>
                            <FileViewer
                                fileName={dataFileView.current?.fileName}
                                filePath={dataFileView.current?.filePath}
                                fileType={dataFileView.current?.fileType}
                            />
                        </ModalBody>
                    </Modal>}
                {formLoading && <Loading />}
                {!Config.isEmpty(dataMaster) &&
                    <Row>
                        <Col xs={12} className={'mgv2x'}>
                            <Row>
                                <Col xs={12} sm={7}>
                                    <Image width={'100%'} height={'auto'} src={ImageINV} />
                                </Col>
                                <Col xs={12} sm={5}>
                                    <Typography type={'title4'} lineClamp={1} hoverTooltip>{InventoryName}</Typography>
                                    <Typography type={'h3'} className={'mgt2x'}>{Config.lang('Quy_cach')}:</Typography>
                                    <Typography>{SpecificationsINV}</Typography>
                                    <Typography type={'h3'} className={'mgt2x'}>{Config.lang('Don_vi_tinh')}:</Typography>
                                    <Typography>{UnitID}</Typography>
                                    <Typography type={'h3'} className={'mgt2x'}>{Config.lang('Thong_tin_san_pham')}:</Typography>
                                    <Typography {...(readMore ? {} : { lineClamp: 5 })}>{DesINV}</Typography>
                                    {!Config.isEmpty(DesINV) && <Button className={'mgt1x'} viewType={'link'} onClick={() => setReadMore(!readMore)}>{Config.lang(readMore ? 'Thu_gon' : 'Xem_them')}</Button>}
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} className={'mgb2x'}>
                            <Typography type={'h3'}>{Config.lang('Chuong_trinh_khuyen_mai')}</Typography>
                            {renderAttachment}
                        </Col>
                    </Row>
                }
                <a id={'linkDownload'} href={'/#'} download={''} className={'hide'}>File</a>
            </ModalBody>
        </Modal>
    );
}));

export default INVHotModal;